import { createI18n } from 'vue-i18n'
import { es, en, pt } from './messages'
import type { AppLocale } from '@/types/settings'

/**
 * Instancia de vue-i18n.
 *
 * El locale inicial es 'es' (fallback); `setLocale` lo cambia en caliente
 * y lo persiste vía el store de settings. Los mensajes se cargan de forma
 * síncrona (ya están en el bundle) porque la app es offline-first y no
 * queremos dependencia de red para mostrar la UI.
 *
 * En componentes se usa `$t('key')` (template) o `useI18n().t` (script).
 * Fuera de componentes (stores, composables) se usa `i18n.global.t`.
 */
export const i18n = createI18n({
  legacy: false,
  locale: 'es',
  fallbackLocale: 'es',
  messages: { es, en, pt },
})

/** Cambia el locale activo. */
export function setLocale(locale: AppLocale) {
  i18n.global.locale.value = locale
  // Actualizar el atributo lang del documento para lectores/accesibilidad.
  document.documentElement.lang = locale
}

/**
 * Traduce fuera del contexto de un componente (stores, módulos sueltos).
 * Equivale a `$t` dentro de un componente.
 */
export function t(key: string, named?: Record<string, unknown>): string {
  return i18n.global.t(key, named ?? ({} as Record<string, unknown>))
}
